import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
`;

export const Container = styled.div`
  padding: 21px;
`;
